export const T = {
  en_GB: {
    addCommitment: "Add Commitment",
    noItemsYet: "No items added yet. Click the button above to add.",
    fieldLabels: {
      housing: "Housing Costs",
      insurance: "Insurance Premiums",
      dependent_care: "Dependent Care",
      education: "Education Expenses",
      alimony: "Alimony/Child Support",
      other_fixed: "Other Fixed Costs",
    },
  },
  nb_NO: {
    addCommitment: "Legg til forpliktelse",
    noItemsYet: "Ingen poster lagt til ennå. Klikk på knappen over for å legge til.",
    fieldLabels: {
      housing: "Boligkostnader",
      insurance: "Forsikringspremier",
      dependent_care: "Omsorgskostnader",
      education: "Utdanningskostnader",
      alimony: "Barnebidrag/underholdsbidrag",
      other_fixed: "Andre faste kostnader",
    },
  },
} as const;
